import * as ko from 'knockout';
const MONTHS_DE = [
    'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
    'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
];
const DAYS_DE = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
function formatDate(d) {
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}.${mm}.${yyyy}`;
}
function parseDate(s) {
    const m = s.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    if (!m)
        return null;
    return new Date(+m[3], +m[2] - 1, +m[1]);
}
function isSameDay(a, b) {
    return a.getDate() === b.getDate() && a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear();
}
function buildCalendar(container, viewYear, viewMonth, selected, onSelect, onNav) {
    container.innerHTML = '';
    // Header with nav
    const header = document.createElement('div');
    header.className = 'de-cal-header';
    const prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'de-cal-nav';
    prevBtn.textContent = '\u25C0';
    prevBtn.addEventListener('click', (e) => { e.stopPropagation(); onNav(viewMonth === 0 ? viewYear - 1 : viewYear, viewMonth === 0 ? 11 : viewMonth - 1); });
    const title = document.createElement('span');
    title.className = 'de-cal-title';
    title.textContent = `${MONTHS_DE[viewMonth]} ${viewYear}`;
    const nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'de-cal-nav';
    nextBtn.textContent = '\u25B6';
    nextBtn.addEventListener('click', (e) => { e.stopPropagation(); onNav(viewMonth === 11 ? viewYear + 1 : viewYear, viewMonth === 11 ? 0 : viewMonth + 1); });
    header.appendChild(prevBtn);
    header.appendChild(title);
    header.appendChild(nextBtn);
    container.appendChild(header);
    // Day-of-week headers
    const dowRow = document.createElement('div');
    dowRow.className = 'de-cal-row';
    DAYS_DE.forEach(d => {
        const cell = document.createElement('div');
        cell.className = 'de-cal-dow';
        cell.textContent = d;
        dowRow.appendChild(cell);
    });
    container.appendChild(dowRow);
    // Days grid
    const firstDay = new Date(viewYear, viewMonth, 1);
    // getDay() returns 0=Sun. Convert to Mon=0 ... Sun=6
    let startDow = (firstDay.getDay() + 6) % 7;
    const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
    const today = new Date();
    let row = document.createElement('div');
    row.className = 'de-cal-row';
    // Empty cells before first day
    for (let i = 0; i < startDow; i++) {
        const empty = document.createElement('div');
        empty.className = 'de-cal-cell de-cal-empty';
        row.appendChild(empty);
    }
    for (let day = 1; day <= daysInMonth; day++) {
        const cellDate = new Date(viewYear, viewMonth, day);
        const cell = document.createElement('button');
        cell.type = 'button';
        cell.className = 'de-cal-cell de-cal-day';
        cell.textContent = String(day);
        if (isSameDay(cellDate, today)) {
            cell.classList.add('de-cal-today');
        }
        if (selected && isSameDay(cellDate, selected)) {
            cell.classList.add('de-cal-selected');
        }
        cell.addEventListener('click', (e) => { e.stopPropagation(); onSelect(cellDate); });
        row.appendChild(cell);
        if ((startDow + day) % 7 === 0) {
            container.appendChild(row);
            row = document.createElement('div');
            row.className = 'de-cal-row';
        }
    }
    // Append last row if it has cells
    if (row.children.length > 0) {
        container.appendChild(row);
    }
}
ko.bindingHandlers['germanDatepicker'] = {
    init: function (element, valueAccessor) {
        const observable = valueAccessor();
        // Create calendar container
        const wrapper = document.createElement('div');
        wrapper.className = 'de-cal-wrapper';
        element.parentNode.insertBefore(wrapper, element.nextSibling);
        const dropdown = document.createElement('div');
        dropdown.className = 'de-cal-dropdown';
        dropdown.style.display = 'none';
        wrapper.appendChild(dropdown);
        let viewYear;
        let viewMonth;
        function initView() {
            const parsed = parseDate(observable());
            const d = parsed || new Date();
            viewYear = d.getFullYear();
            viewMonth = d.getMonth();
        }
        function render() {
            const selected = parseDate(observable());
            buildCalendar(dropdown, viewYear, viewMonth, selected, (d) => {
                observable(formatDate(d));
                dropdown.style.display = 'none';
            }, (y, m) => {
                viewYear = y;
                viewMonth = m;
                render();
            });
        }
        function show() {
            initView();
            render();
            dropdown.style.display = 'block';
        }
        function hide(e) {
            if (!wrapper.contains(e.target) && e.target !== element) {
                dropdown.style.display = 'none';
            }
        }
        // Make input readonly so users must use the calendar
        element.readOnly = true;
        element.style.cursor = 'pointer';
        element.addEventListener('click', (e) => {
            e.stopPropagation();
            if (dropdown.style.display === 'none') {
                show();
            }
            else {
                dropdown.style.display = 'none';
            }
        });
        document.addEventListener('click', hide);
        ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
            document.removeEventListener('click', hide);
            wrapper.remove();
        });
    },
    update: function (element, valueAccessor) {
        element.value = ko.unwrap(valueAccessor()) || '';
    }
};
